<template>
	<div class="bottom">
		<p><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">沪ICP备2024090295号</a> 沪网信备31010424166722010020号</p>
		<p>为确保最佳浏览效果，建议您使用以下浏览器版本：IE浏览器9.0版本及以上； Google Chrome浏览器 63版本及以上； 360浏览器9.1版本及以上，且IE内核9.0及以上。</p>
	</div>
</template>

<script>
export default {
	name: 'Footer',
	props: {
		hash: String
	},
	data() {
		return {
			isShow: true
		}
	},
	methods: {
		goContactPage() {
			this.$router.push({ path: '/contactUs' });
			window.scrollTo(0, 0);
		}
	}
}
</script>

<style lang="less" scoped>
.bottom {
	width: 100%;
	background: #002e94;
	padding: 50px 15px;
	text-align: center;

	p {
		font-size: 14px;
		color: #fff;
		margin-bottom: 18px;
	}

	a,a:link,a:visited {
		color: #fff;
	}
}

.middle {
	width: 100%;
	margin: 0 auto;
}

.contact {
	width: 100%;
	background: linear-gradient(to right, #0ab8f0, #44d9e2, #7ffed8);
	height: 100px;
	line-height: 100px;

	a {
		display: inline-block;
		padding: 0 100px;
		height: 50px;
		line-height: 50px;
		border-radius: 50px;
		text-align: center;
		font-size: 22px;
		color: #FFFFFF;
		background: rgba(255, 255, 255, 0.2);
		text-decoration: none;
	}

	a:hover {
		background: rgba(245, 245, 245, 0.5);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue